import { cloneDeep } from "lodash"

export default function transformSets(sets) {
  const setsObj = cloneDeep(sets)

  if (setsObj.assessmentSet) {
    const { assessmentSet, assessmentSubtests, destructuredSubtests } = setsObj
    groupifySet(assessmentSet, assessmentSubtests, destructuredSubtests)
  } else {
    for (const setId in setsObj) {
      const { assessmentSet, assessmentSubtests, destructuredSubtests } =
        setsObj[setId]
      groupifySet(assessmentSet, assessmentSubtests, destructuredSubtests)
    }
  }

  return setsObj
}

function groupifySet(assessmentSet, assessmentSubtests, destructuredSubtests) {
  if (assessmentSet?.testCategory) {
    const groupedSubtests = {}
    for (const subtestId in assessmentSubtests) {
      if (assessmentSubtests[subtestId].groupName) {
        const { groupName, nodeTag, maxNodeLevels, index } =
          assessmentSubtests[subtestId]
        if (!groupedSubtests[groupName]) {
          groupedSubtests[groupName] = {
            displayName: groupName,
            name: groupName,
            maxNodeLevels,
            nodeTag,
            index,
            isGrouped: true,
            childs: {
              [subtestId]: assessmentSubtests[subtestId]
            }
          }
        }
        groupedSubtests[groupName].childs[subtestId] =
          assessmentSubtests[subtestId]
      }
    }
    if (Object.keys(groupedSubtests).length) {
      for (const group in groupedSubtests) {
        const { childs } = groupedSubtests[group]
        const subtestIds = Object.keys(childs).sort(
          (a, b) => assessmentSubtests[a].index - assessmentSubtests[b].index
        )
        const groupedSubtestId = subtestIds.join("_")
        if (groupedSubtestId) {
          const values = []
          const destItemsBySubtest = []
          let destItems = []
          let rawToScaleScoring = {}
          let totalItems = 0

          subtestIds.forEach(subtestId => {
            const sTest = childs[subtestId]
            totalItems += destructuredSubtests[subtestId].items.length
            destItemsBySubtest.push(
              destructuredSubtests[subtestId].items.slice()
            )

            if (!values.length) {
              values.push(...Object.values(sTest.rawToScaleScoring))
            } else {
              const nextScaleValues = Object.values(sTest.rawToScaleScoring)
              nextScaleValues.shift()
              values.push(...nextScaleValues)
            }
          })

          while (totalItems) {
            destItemsBySubtest.forEach(items => {
              if (items.length) {
                destItems = [...destItems, items.shift()]
                totalItems--
              }
            })
          }

          values.forEach((v, i) => {
            if (assessmentSet.testCategory === "SAT") {
              rawToScaleScoring[i] = v / 20
            } else {
              rawToScaleScoring[i] = v
            }
          })

          assessmentSubtests[groupedSubtestId] = {
            setId: groupedSubtestId,
            rawToScaleScoring,
            ...groupedSubtests[group]
          }

          destructuredSubtests[groupedSubtestId] = {
            items: destItems
          }
        }
      }
    }
  }

  return {
    assessmentSet,
    assessmentSubtests,
    destructuredSubtests
  }
}
